import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { Component } from '@angular/core';
import { UiRouterResolverFactory } from '@client/app/shared/ui-router/ui-router-resolver-factory';
import { QualityPagesComponent } from '@client/app/pages/qa/pages/quality-pages.component';
import { QualitySummaryComponent } from '@client/app/pages/qa/summary/quality-summary.component';

@Component({
    selector: 'base-qa',
    template: `<ui-view name="content"></ui-view>`,
    standalone: true,
    imports: [UIRouterModule],
})
class BaseQAComponent {}

export const QA_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.domain.qa',
        url: '/quality',
        abstract: true,
        views: {
            'content@base.customer.domain': {
                component: BaseQAComponent,
            },
        },
        redirectTo: 'base.customer.domain.qa.summary',
        // No shellPath here: abstract parents are not navigation targets.
        // The '/domains/:domainId/quality' prefix is owned by qa.summary below.
        data: {
            sidebar: 'quality',
        },
        resolve: UiRouterResolverFactory.createActiveFeatureStateResolver({
            token: 'hasAccessQualityFeatures',
            pureFeatures: ['qa_module'],
        }),
    },
    {
        name: 'base.customer.domain.qa.pages',
        url: '/pages',
        views: {
            'content@base.customer.domain.qa': {
                component: QualityPagesComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - Content With QA Errors',
            /** Shell-facing path for CC breadcrumb/menu sync (see event-bus-bridge.init.ts) */
            shellPath: '/domains/:domainId/quality/pages',
        },
    },
    {
        name: 'base.customer.domain.qa.summary',
        url: '/summary',
        views: {
            'content@base.customer.domain.qa': {
                component: QualitySummaryComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - Quality Assurance',
            shellPath: '/domains/:domainId/quality/summary',
            // Incoming alias: CC breadcrumb clicks on 'Quality' use the module
            // prefix and resolve directly to this landing leaf (parents are silent).
            shellAliases: ['/domains/:domainId/quality'],
        },
    },
];
